import { render, staticRenderFns } from "./level-detail.vue?vue&type=template&id=459e1cdc&scoped=true"
import script from "./level-detail.vue?vue&type=script&lang=ts"
export * from "./level-detail.vue?vue&type=script&lang=ts"
import style0 from "./level-detail.vue?vue&type=style&index=0&id=459e1cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e1cdc",
  null
  
)

export default component.exports